import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';

import { NavigationListProvider } from '../providers/navigation-list/navigation-list';

import { TranslateService } from '@ngx-translate/core';

import { Keyboard } from '@ionic-native/keyboard';
import { DataProvider } from '../providers/data/data';
import { LoginProvider } from '../providers/login/login';
import { AppConfig } from '../config/app.config';
import { AccountProvider } from '../providers/account/account';
import { MenuPage } from '../pages/menu/menu';
import { CompanyConfigProvider } from '../providers/company-config/company-config';
import { Network } from '@ionic-native/network';
import { NetworkInfoProvider } from '../providers/network-info/network-info';
import { AlertProvider } from '../providers/alert/alert';

@Component({
  template: `<ion-nav #baseNav></ion-nav>`
})
export class MyApp {
  @ViewChild('baseNav') nav: Nav;

  // navList: NavigationListProvider;

  constructor(private translate: TranslateService,
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public navigationList: NavigationListProvider,
    public keyboard: Keyboard,
    public config: AppConfig,
    public login: LoginProvider,
    public accountProvider: AccountProvider,
    public companyConfigProvider: CompanyConfigProvider,
    private network: Network,
    private networkInfoProvider: NetworkInfoProvider,
    private alertProvider: AlertProvider) {

    networkInfoProvider.isConnected().then(x => {
      if(!x) {
        alertProvider.simple('No Internet', 'No internet connection detected.');
      }
    });

    // watch network for a disconnect
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      alertProvider.simple('No Internet', 'No internet connection detected.');
    });

    config.loaded.then(() => {

      this.companyConfigProvider.syncCompanyConfig();

      // this language will be used as a fallback when a translation isn't found in the current language
      this.translate.setDefaultLang(config.language);
      this.initializeApp();

      accountProvider.getAccount().then((customer) => {
	    if(customer.is_active == 0){
		    this.logout();
	    }
        if (customer && customer.prefered_language) {
          this.translate.use(customer.prefered_language);
        }
      });
    });
  }

  logout() {
    this.login.logout();
  }

  ngOnInit() {
    
    
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();

      this.login.isAuthenticated().then(x => {
        if (x && x == true) {
          this.navigationList.loadCategoryListItems().then(() => {
            this.nav.setRoot(MenuPage, { animate: false });
            this.splashScreen.hide();
          }).catch(err => {
            this.nav.setRoot(LoginPage, { animate: false });
            this.splashScreen.hide();
          });
        } else {
          this.nav.setRoot(LoginPage, { animate: false });
          this.splashScreen.hide();
        }
      });
      this.login.loginStateEventEmitter.on("LoggedOut", () => {
        if (this.nav.root != LoginPage) {
          this.nav.setRoot(LoginPage, { animate: false });
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts